import $ from 'jquery';
import DocumentLabelModal from '@/views/analyse/registre_analyse/components/DocumentLabelModal.vue';
import PreviewGroupedAnalysesModal from '@/views/analyse/registre_analyse/components/PreviewGroupedAnalysesModal.vue';
import PrintedGroupedAnalysis from '@/views/analyse/registre_analyse/components/PrintedGroupedAnalysis.vue';
import VoirResultat from '@/views/analyse/visualiser-resultat';

import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal'

export default {
    name: 'registre-patient',
    components: {
        DocumentLabelModal, PreviewGroupedAnalysesModal, 
        PrintedGroupedAnalysis, VoirResultat,
        ResultatPatientModal
    },
    props: {
        patient: {
            type: Object,
            required: true
        },
        user_id: Number
    },
    data() {
        return {
            tableHeadCells: [
                { key: 'analyse.nom', label: 'Analyses' },
                { key: 'technique_utilisee', label: 'Technique utilisée' },
                { key: 'resultat_est_porte', label: 'Résultat' },
            ],
            currentPage: 1,
            perPage: 5,
            isLoading: false,
            groupedResultsToggled: false,
            groupResults: [],
            isSavingDocument: false,
            isSuccess: false,

            result_preview: {},

            isNewResultFetching: false,

            results: undefined,
            showPrintedResults: false,
            view_result_loading: false,
            can_print: false,
            liste_analyses: [],
            toggler: 0,
        }
    },

    watch: {
        patient: {
            handler: function (newValue) {
                this.groupResults = [];
                this.showPrintedResults = false;
                this.getBulletinsByPatientId(newValue.id);
            },
            deep: true
        },
        groupedResultsToggled: {
            handler: function (newValue) {
                if (newValue) {
                    this.tableHeadCells.push({ key: 'action', label: 'Action(s)' });
                } else {
                    this.tableHeadCells.pop();

                    this.patientBulletins.forEach(b => {
                        b.checked = false;
                        b.demandes_analyses.forEach(d => d.checked = false);
                    });
                }
                this.groupResults = [];
            }
        },
        showPrintedResults: {
            handler: function (newValue) {
                if (newValue) {
                    this.groupedResultsToggled = false;
                    this.$store.dispatch('getGroupedAnalysesByPatientId', this.patient.id);
                }
            }
        },
    },

    computed: {
        patientBulletins() {
            return this.$store.getters.patientBulletins;
        },

        showNextStepButton() {// Il faut au moins 02 demandes sinon ça n'as pas de sens
            const demandesCount = this.groupResults.reduce((total, bulletin) => {
                return total + bulletin.demandes_analyses.length;
            }, 0);

            return demandesCount >= 2;
        },

        patientPrintedGroupedResults() {
            return this.$store.getters.patientPrintedGroupedResults;
        }
    },

    mounted() {
        this.getBulletinsByPatientId(this.patient.id);
    },
    
    methods: {
        async getBulletinsByPatientId(id) {
            this.isLoading = true;
            const response = await this.$store.dispatch('getBulletinsByPatientId', id);

            this.isLoading = false;

            if (response.status === 200) {
                this.$store.dispatch('setPatientBulletins', response.data);
            }
        },
        
        async rowClicked(item) {
            this.toggler = (this.toggler == 0)?1:0
            this.view_result_loading = true
            if (this.is_modele_analyse) {
                if (item.resultat_est_porte == 1 && item.resultat_fichier == null) {
                    $("#view-analysis-modal").modal('show');
    
                    const demande_analyse_id = item.id
                    this.$store.dispatch("getResultsByAnalyseIdBulletinId", { demande_analyse_id }).then((response) => {
                        this.results = response.data
                        this.view_result_loading = false
                    })
                } else {
                    const demande = {
                        analyse_nom: item.analyse.nom,
                        resultat_fichier: item.resultat_fichier,
                        commentaires: item.commentaires
                    };
        
                    this.result_preview = demande;
                    $('#modalResultat').modal('show');
                }
            } else {
                const demande = {
                    analyse_nom: item.analyse.nom,
                    resultat_fichier: item.resultat_fichier,
                    commentaires: item.commentaires
                };
    
                this.result_preview = demande;
                $('#modalResultat').modal('show');
            }
        },

        toggleGroupResults() {
            this.groupedResultsToggled = !this.groupedResultsToggled;
            this.showPrintedResults = false;
        },

        onToggleBulletinAnalyses(checked, bulletin) {
            if (checked) {
                const resultedDemandes = bulletin.demandes_analyses.filter(d => d.resultat_est_porte === 1);
                const newBulletin = {
                    ...bulletin,
                    demandes_analyses: resultedDemandes
                };

                this.groupResults = [...this.groupResults, newBulletin];
            } else {
                this.groupResults = this.groupResults.filter(b => b.id !== bulletin.id);
            }
            this.updatePatientBulletins(checked, bulletin);
        },

        onToggleSingleAnalyseRow(checked, bulletin, demandeAnalyse) {
            if (checked) {
                const newBulletin = {
                    ...bulletin,
                    demandes_analyses: [demandeAnalyse]
                };

                if (!this.groupResults.some(b => b.id === bulletin.id)) {
                    this.groupResults = [newBulletin, ...this.groupResults];
                } else {
                    this.groupResults = this.groupResults.map(b => {
                        if (b.id === bulletin.id) {
                            return {
                                ...b,
                                demandes_analyses: [...b.demandes_analyses, demandeAnalyse]
                            }
                        }
                        return b;
                    });
                }
            } else {
                this.groupResults = this.groupResults.map(b => {
                    if (b.id === bulletin.id) {
                        return {
                            ...b,
                            demandes_analyses: b.demandes_analyses.filter(d => d.id !== demandeAnalyse.id)
                        }
                    }
                    return b;
                });
            }
        },

        updatePatientBulletins(checked, bulletin) {
            const patientBulletins = this.patientBulletins.map(b => {
                if (b.id === bulletin.id) {
                    return {
                        ...b,
                        demandes_analyses: b.demandes_analyses.map(d => {
                            if (d.resultat_est_porte === 1) {
                                return {
                                    ...d,
                                    checked: checked
                                }
                            }
                            return d;
                        })
                    }
                }
                return b;
            });
            this.$store.dispatch('setPatientBulletins', patientBulletins);
        },

        async handleSaveGroupedAnalyses(documentDetails) {

            const groupedAnalysisObject = {
                data: {
                    ...documentDetails,
                    bulletins: this.groupResults.map(gr => ({
                        id: gr.id,
                        demandes_analyses: gr.demandes_analyses.map(da => da.id)
                    })),
                    saved_by: this.user_id,
                },
                patientId: this.patient.id,
            };

            this.isSavingDocument = true;


            const response = await this.$store.dispatch('saveGroupedAnalyses', groupedAnalysisObject);

            this.$bvModal.hide('document-label-modal');
            
            if (response.status === 201 || response.status === 200) {
                this.isSuccess = true;
                
                this.successToast('Document prêt pour la prévisualisation');

                this.groupedResultsToggled = false;
                this.groupResults = [];

                setTimeout(() => {
                    $('#preview-grouped-analyses-modal').modal('show');
                }, 200);
            } else{
                this.errorToast('Une erreur est survenue lors de l’enregistrement du document');
            }
            
            this.isSavingDocument = false;
        },

        printResultatAnalyse(results) {
            this.$emit('emitPrintResultat', results)
        },

        groupedResultToPrint(results) {
            this.$emit('emitPrintGroupedResultat', results)
        }
    }
}